import { useCallback, useEffect, useState } from "react";

import Navigation from "@/components/maison/Navigation";
import Footer from "@/components/maison/Footer";

import UFJHero from "@/components/maison/ultrafine/UFJHero";
import UFJIntroduction from "@/components/maison/ultrafine/UFJIntroduction";
import UFJCategories from "@/components/maison/ultrafine/UFJCategories";
import UFJPieces from "@/components/maison/ultrafine/UFJPieces";
import { fetchPieces } from "@/lib/api";
import UFJEditorial from "@/components/maison/ultrafine/UFJEditorial";
import UFJBespoke from "@/components/maison/ultrafine/UFJBespoke";
import UFJPrivateClientBand from "@/components/maison/ultrafine/UFJPrivateClientBand";
import UFJPrivateClientDialog from "@/components/maison/ultrafine/UFJPrivateClientDialog";

function scrollToId(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function UltraFineJewelryPage() {
  const [dialog, setDialog] = useState({ open: false, piece: null, mode: "inquire" });
  const [pieces, setPieces] = useState([]);

  useEffect(() => {
    fetchPieces().then(setPieces).catch(() => setPieces([]));
  }, []);

  // Ensure the page starts at the hero when navigated to.
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    // SEO
    const prevTitle = document.title;
    document.title = "Ultra Fine Jewelry — PiérrecDavís Maison";
    const metaDesc = document.querySelector('meta[name="description"]');
    const prevDesc = metaDesc?.getAttribute("content");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "PiérrecDavís Ultra Fine Jewelry — exceptional creations by private appointment. Haute joaillerie, rare gemstones and bespoke commissions."
      );
    }
    return () => {
      document.title = prevTitle;
      if (metaDesc && prevDesc != null) metaDesc.setAttribute("content", prevDesc);
    };
  }, []);

  const openInquiry = useCallback((piece = null) => {
    setDialog({ open: true, piece, mode: "inquire" });
  }, []);
  const openCommission = useCallback(() => {
    setDialog({ open: true, piece: null, mode: "commission" });
  }, []);
  const handleBand = useCallback(({ mode }) => {
    setDialog({ open: true, piece: null, mode: mode || "inquire" });
  }, []);
  const closeDialog = useCallback(() => setDialog((d) => ({ ...d, open: false })), []);

  return (
    <div className="bg-black text-white" data-testid="ultra-fine-jewelry-page">
      <Navigation />
      <UFJHero
        onDiscover={() => scrollToId("ufj-collection")}
        onPrivateViewing={() => openInquiry()}
      />
      <UFJIntroduction />
      <UFJCategories pieces={pieces} onInquire={(cat) => openInquiry(cat)} />
      <UFJPieces pieces={pieces} />
      <UFJEditorial onInquire={(cat) => openInquiry(cat)} />
      <UFJBespoke onBeginCommission={openCommission} />
      <UFJPrivateClientBand onInquire={handleBand} />
      <Footer />

      <UFJPrivateClientDialog
        open={dialog.open}
        piece={dialog.piece}
        mode={dialog.mode}
        onClose={closeDialog}
      />
    </div>
  );
}
